import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DatabaseTwoToneSvg from "@ant-design/icons-svg/es/asn/DatabaseTwoTone";
import AntdIcon from '../components/AntdIcon';
var DatabaseTwoTone = function DatabaseTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DatabaseTwoToneSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DatabaseTwoTone);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DatabaseTwoTone';
}
export default RefIcon;